export type Theme = 'light' | 'dark'

export const THEME_STORAGE_KEY = 'napaicp.theme'

function isTheme(value: string | null | undefined): value is Theme {
  return value === 'light' || value === 'dark'
}

/**
 * Resolves the theme to boot with, in priority order:
 * 1. A previously persisted choice in localStorage (the theme toggle).
 * 2. The OS-level `prefers-color-scheme`.
 * 3. Light.
 *
 * Mirrors `resolveInitialLocale` in `./i18n.ts` — an explicit local choice
 * always wins over any ambient signal.
 */
export function resolveInitialTheme(): Theme {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY)
    if (isTheme(stored)) {
      return stored
    }
    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
      return 'dark'
    }
  }
  return 'light'
}

export function persistTheme(theme: Theme): void {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme)
  }
}

/** Toggles the `.dark` class the design system's CSS variables key off. */
export function applyTheme(theme: Theme): void {
  if (typeof document !== 'undefined') {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }
}
